export default __webpack_public_path__ + "static/media/Fi_Appear.6dcaf81f.wav";